var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","mx-auto":"","px-3":"","py-5":"","grid-list-xxl":""}},[_c('Post',{attrs:{"right":_vm.right,"lift":_vm.lift}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }